import { type I18n, createI18n } from 'vue-i18n';
import { getFromLocalStorage } from '@/utils/storage';
import elementEnLocale from 'element-plus/es/locale/lang/en';
import elementZhLocale from 'element-plus/es/locale/lang/zh-cn';
import enLocale from './en';
import zhLocale from './zh-cn';

export const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale,
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale,
  },
};

const lang:string = navigator.language.startsWith('zh') ? 'zh-cn' : 'en';
type I18nTranslationRestParameters = [string, any]

export const i18n: I18n = createI18n({
  legacy: false,
  locale: getFromLocalStorage('lang') || lang,
  fallbackLocale: 'en',
  messages,
  globalInjection: true,
});

export function transformI18n(message: any = '', ...arg: any[]) {
  if (!message) {
    return '';
  }
  return i18n.global.t.call(i18n.global.locale, message, ...(arg as I18nTranslationRestParameters));
}

export function useI18n(app: any) {
  app.use(i18n);
}
